import { render, staticRenderFns } from "./SalesClosuresDetails.vue?vue&type=template&id=a0248efa"
import script from "./SalesClosuresDetails.vue?vue&type=script&lang=js"
export * from "./SalesClosuresDetails.vue?vue&type=script&lang=js"
import style0 from "./SalesClosuresDetails.vue?vue&type=style&index=0&id=a0248efa&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/latinad/panel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a0248efa')) {
      api.createRecord('a0248efa', component.options)
    } else {
      api.reload('a0248efa', component.options)
    }
    module.hot.accept("./SalesClosuresDetails.vue?vue&type=template&id=a0248efa", function () {
      api.rerender('a0248efa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/popups/closings-details/components/SalesClosuresDetails.vue"
export default component.exports